import type { PERMISSION_VALUE } from '@/permissions'
import {
  type ARCHIVE_PROJECT_PERMISSION,
  type BLOCK_NOTE_MODAL_PERMISSION,
  type BLOCK_PERMISSION,
  type COMMENTS_PERMISSION,
  type EDITOR_PERMISSION,
  type ESTIMATE_PERMISSION,
  type EXPORT_PERMISSION,
  type FIGMA_PREVIEWS_PERMISSION,
  type FILE_ATTACHMENTS_PERMISSION,
  type GA4_PERMISSION,
  getArchiveProjectPermissionsMatrix,
  getBlockNoteModalPermissionsMatrix,
  getBlockPermissionsMatrix,
  getCommentsPermissionsMatrix,
  getEditorPermissionsMatrix,
  getEstimatePermissionsMatrix,
  getExportPermissionsMatrix,
  getFigmaPreviewsPermissionsMatrix,
  getFileAttachmentPermissionsMatrix,
  getGa4PermissionsMatrix,
  getPagePermissionsMatrix,
  getProjectSettingsPermissionsMatrix,
  getProjectTitlePermissionsMatrix,
  getPublishPermissionsMatrix,
  getSectionsPermissionsMatrix,
  getSeoTagsPermissionsMatrix,
  getSharePermissionsMatrix,
  getStickyNotesPermissionsMatrix,
  getTabsPermissionsMatrix,
  getTagsPermissionsMatrix,
  getToolbarIconsPermissionsMatrix,
  getVersionHistoryPermissionsMatrix,
  getWireframesPermissionsMatrix,
  type PAGE_PERMISSION,
  type PROJECT_SETTINGS_PERMISSION,
  type PROJECT_TITLE_PERMISSION,
  type PUBLISH_PERMISSION,
  type SECTIONS_PERMISSION,
  type SEO_TAGS_PERMISSION,
  type SHARE_PERMISSION,
  type STICKY_NOTES_PERMISSION,
  type TABS_PERMISSION,
  type TAGS_PERMISSION,
  type TOOLBAR_ICONS_PERMISSION,
  type VERSION_HISTORY_PERMISSION,
  type WIREFRAMES_PERMISSION,
} from './definitions'

export enum ROLE_TYPE {
  TRIAL_ANONYMOUS = 'TRIAL_ANONYMOUS',
  TRIAL_LOGGED = 'TRIAL_LOGGED',

  FREE_ANONYMOUS = 'FREE_ANONYMOUS',
  FREE_LOGGED = 'FREE_LOGGED',
  FREE_PROJECT_MEMBER = 'FREE_PROJECT_MEMBER',
  FREE_OWNER = 'FREE_OWNER',

  PRO_ANONYMOUS = 'PRO_ANONYMOUS',
  PRO_LOGGED = 'PRO_LOGGED',
  PRO_PROJECT_MEMBER = 'PRO_PROJECT_MEMBER',
  PRO_OWNER = 'PRO_OWNER',

  TEAM_AGENCY_ANONYMOUS = 'TEAM_AGENCY_ANONYMOUS',
  TEAM_AGENCY_LOGGED = 'TEAM_AGENCY_LOGGED',
  TEAM_AGENCY_PROJECT_MEMBER = 'TEAM_AGENCY_PROJECT_MEMBER',
  TEAM_AGENCY_MEMBER = 'TEAM_AGENCY_MEMBER',
  TEAM_AGENCY_OWNER = 'TEAM_AGENCY_OWNER',
}

export type PROJECT_PERMISSION =
  | TOOLBAR_ICONS_PERMISSION
  | PAGE_PERMISSION
  | BLOCK_PERMISSION
  | BLOCK_NOTE_MODAL_PERMISSION
  | WIREFRAMES_PERMISSION
  | PROJECT_SETTINGS_PERMISSION
  | VERSION_HISTORY_PERMISSION
  | ESTIMATE_PERMISSION
  | EXPORT_PERMISSION
  | SHARE_PERMISSION
  | FIGMA_PREVIEWS_PERMISSION
  | GA4_PERMISSION
  | SEO_TAGS_PERMISSION
  | COMMENTS_PERMISSION
  | STICKY_NOTES_PERMISSION
  | EDITOR_PERMISSION
  | TAGS_PERMISSION
  | PROJECT_TITLE_PERMISSION
  | SECTIONS_PERMISSION
  | TABS_PERMISSION
  | PUBLISH_PERMISSION
  | FILE_ATTACHMENTS_PERMISSION
  | ARCHIVE_PROJECT_PERMISSION

export const getPermissionsMatrix = (): Record<
  PROJECT_PERMISSION | string,
  Record<ROLE_TYPE, PERMISSION_VALUE>
> => {
  return {
    ...getToolbarIconsPermissionsMatrix(),
    ...getPagePermissionsMatrix(),
    ...getBlockPermissionsMatrix(),
    ...getBlockNoteModalPermissionsMatrix(),
    ...getWireframesPermissionsMatrix(),
    ...getProjectSettingsPermissionsMatrix(),
    ...getVersionHistoryPermissionsMatrix(),
    ...getEstimatePermissionsMatrix(),
    ...getExportPermissionsMatrix(),
    ...getSharePermissionsMatrix(),
    ...getFigmaPreviewsPermissionsMatrix(),
    ...getGa4PermissionsMatrix(),
    ...getSeoTagsPermissionsMatrix(),
    ...getCommentsPermissionsMatrix(),
    ...getStickyNotesPermissionsMatrix(),
    ...getEditorPermissionsMatrix(),
    ...getTagsPermissionsMatrix(),
    ...getProjectTitlePermissionsMatrix(),
    ...getSectionsPermissionsMatrix(),
    ...getTabsPermissionsMatrix(),
    ...getPublishPermissionsMatrix(),
    ...getFileAttachmentPermissionsMatrix(),
    ...getArchiveProjectPermissionsMatrix(),
  }
}
